import concepts from '@/apis/kitchens/concepts'
import { conceptsTypes } from '@/store/mutationTypes'

export default {
    namespaced: true,
    state: {
        all: null,
        fetchAll: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [conceptsTypes.FETCH_ALL_REQUEST]: function (state) {
            state.fetchAll.pending = true;
        },
        [conceptsTypes.FETCH_ALL_SUCCESS]: function (state, concepts) {
            state.all = concepts;
            state.fetchAll.error = null;
            state.fetchAll.pending = false;
        },
        [conceptsTypes.FETCH_ALL_FAILURE]: function (state, error) {
            state.all = null;
            state.fetchAll.error = error;
            state.fetchAll.pending = false;
        },
    },
    actions: {
        async fetchAll({ commit }) {
            commit(conceptsTypes.FETCH_ALL_REQUEST)
            return new Promise((resolve, reject) => {
                concepts
                    .fetchAll()
                    .then((conceptsList) => {
                        commit(conceptsTypes.FETCH_ALL_SUCCESS, conceptsList.data)
                        resolve(conceptsList.data)
                    })
                    .catch((error) => {
                        commit(conceptsTypes.FETCH_ALL_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}